<template>
  <svg width="50" height="51" viewBox="0 0 50 51" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="path-1-inside-1_371_39451" fill="white">
      <path
        d="M0 11.6367C0 5.56159 4.92487 0.636719 11 0.636719H39C45.0751 0.636719 50 5.56159 50 11.6367V39.6367C50 45.7118 45.0751 50.6367 39 50.6367H11C4.92487 50.6367 0 45.7118 0 39.6367V11.6367Z" />
    </mask>
    <path
      d="M0 11.6367C0 5.56159 4.92487 0.636719 11 0.636719H39C45.0751 0.636719 50 5.56159 50 11.6367V39.6367C50 45.7118 45.0751 50.6367 39 50.6367H11C4.92487 50.6367 0 45.7118 0 39.6367V11.6367Z"
      fill="#319AE6" />
    <path
      d="M0 11.6367C0 5.56159 4.92487 0.636719 11 0.636719H39C45.0751 0.636719 50 5.56159 50 11.6367V39.6367C50 45.7118 45.0751 50.6367 39 50.6367H11C4.92487 50.6367 0 45.7118 0 39.6367V11.6367Z"
      fill="url(#paint0_linear_371_39451)" />
    <path
      d="M0 11.6367C0 5.0093 5.37258 -0.363281 12 -0.363281H38C44.6274 -0.363281 50 5.0093 50 11.6367C50 6.11387 45.0751 1.63672 39 1.63672H11C4.92487 1.63672 0 6.11387 0 11.6367ZM50 50.6367H0H50ZM0 50.6367V0.636719V50.6367ZM50 0.636719V50.6367V0.636719Z"
      fill="white" fill-opacity="0.5" mask="url(#path-1-inside-1_371_39451)" />
    <path
      d="M17.5694 39.7484H17.52C17.5275 39.725 17.5325 39.701 17.535 39.6765C17.535 38.2562 17.5394 36.8356 17.5294 35.4153C17.5144 35.3065 17.4571 35.2081 17.37 35.1412C16.3871 34.3835 15.527 33.4787 14.82 32.4587C13.2716 30.2817 12.5808 27.61 12.8797 24.9553C13.1644 22.1352 14.5261 19.5338 16.6813 17.6928C19.6363 15.0856 23.1203 14.0644 27.0191 14.4744C29.9482 14.751 32.689 16.0409 34.7691 18.1215C36.3904 19.6867 37.4986 21.7069 37.9472 23.9153C38.0494 24.4153 38.1034 24.9231 38.1791 25.4278V26.8153C38.1601 26.886 38.1456 26.9578 38.1356 27.0303C38.0169 28.7421 37.4758 30.3978 36.5606 31.8494C34.1116 35.705 30.5169 37.5906 26.0197 37.8556C24.6984 37.9264 23.3744 37.7832 22.0988 37.4315C22.021 37.4091 21.9393 37.4035 21.8592 37.415C21.7791 37.4266 21.7024 37.455 21.6341 37.4984C20.9878 37.8628 20.3334 38.2128 19.6841 38.5719C18.9778 38.9622 18.2741 39.3569 17.5691 39.7497M33.5822 22.9475L33.5491 22.9122L27.4672 26.2787L24.1566 22.8347L17.3616 30.05L17.3978 30.0987L23.5266 26.7497L26.7572 30.1931L33.5822 22.9475Z"
      fill="white" />
    <defs>
      <linearGradient id="paint0_linear_371_39451" x1="45.25" y1="0.636718" x2="7.75" y2="45.8867"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F26462" />
        <stop offset="0.464" stop-color="#9A30ED" />
        <stop offset="1" stop-color="#058CF2" />
      </linearGradient>
    </defs>
</svg></template>
  
<script>
export default {
  name: "ShareViaMessenger",
};
</script>